import { useTheme } from '@mui/material'

interface IMenuIconProps {
  className?: string
}

const MenuIcon = ({ className }: IMenuIconProps) => {
  const theme = useTheme()

  return (
    <svg
      className={className}
      width="20"
      height="14"
      viewBox="0 0 20 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M20 2V0H0V2H20Z" fill={theme.palette.custom.darkBlue2} />
      <path d="M20 6V8H0V6H20Z" fill={theme.palette.custom.darkBlue2} />
      <path d="M10 12V14H0V12H10Z" fill={theme.palette.custom.darkBlue2} />
    </svg>
  )
}

export default MenuIcon
